import React, { useCallback, useContext, useEffect } from 'react'

import {
  useFormDataV2,
  useFormValidation,
  validateIsNotBlankWithLocale,
  validatePhoneWithLocale,
} from '@monorepo/utils'
import PhoneInput from './PhoneInput'
import { RegField } from './types'
import { Locale, ApiCore, useRegister } from '@monorepo/api'
import { ContextApp } from '@monorepo/service'
import { parsePhoneNumber } from 'libphonenumber-js'
import { bonus } from '../../constants'

import RegisterButton from '../RegisterButton'

declare const window: Window &
  typeof globalThis & {
    updateContent?: any
  }

const VALIDATORS = {
  rules: {
    clean_phone: [validateIsNotBlankWithLocale, validatePhoneWithLocale],
  },
  defaultData: {
    clean_phone: '',
  },
}

const FormPhone: React.FC = () => {
  const { sid, setDataRegister } = useContext(ContextApp)

  const { handleRequest, fieldErrorMsg, commonErrorMsg, isLoading } = useRegister({
    sid,
    bonusId: bonus?.bonusId,
    setDataRegister,
  })

  const phoneErrorMessage = fieldErrorMsg ? fieldErrorMsg['clean_phone'] : null

  const { validateForm } = useFormValidation(VALIDATORS.rules)
  const { form, onValidate, setForm } = useFormDataV2({
    validateForm,
    defaultData: VALIDATORS.defaultData,
  })

  // Обработчик изменения телефона
  const handlePhoneChange = useCallback(
    (key: keyof RegField, value: RegField[typeof key]) => {
      setForm((form) => ({
        ...form,
        data: {
          ...form.data,
          [key]: value,
        },
      }))
    },
    [setForm],
  )

  const handleSubmit = useCallback(() => {
    onValidate('clean_phone')((data) => {
      const { nationalNumber, countryCallingCode } = parsePhoneNumber(data.clean_phone)

      handleRequest({
        account_registered_by: ApiCore.PublicAccountRegistrationTypeEnum.PhoneNumber,
        language: Locale.get(),
        country_of_residence: 'KAZ',
        currency: 'KZT',
        privacy_policy: true,
        terms_and_conditions: true,
        receive_promos_enabled: true,
        clean_phone: Number(nationalNumber),
        phone_country_code: `+${countryCallingCode}`,
      })
    })
  }, [handleRequest, onValidate])

  const fields = ['clean_phone']
  const touched = fields.some((field) => form.statuses[field as keyof typeof form.statuses])
  const isFormValid = fields.every(
    (field) => form.statuses[field as keyof typeof form.statuses] === 'valid',
  )

  useEffect(() => {
    window.updateContent?.()
  }, [form.errors])

  return (
    <>
      <div
        className={`hero__form-fields ${touched ? (isFormValid ? 'validForm' : 'invalidForm') : ''}`}
      >
        <PhoneInput
          phoneNumber={form.data.clean_phone}
          onChange={handlePhoneChange}
          onValidate={onValidate}
          error={commonErrorMsg ?? phoneErrorMessage ?? form.errors.clean_phone}
        />
      </div>
      <RegisterButton handleSubmit={handleSubmit} disabled={isLoading} />
    </>
  )
}

export default FormPhone
